import { useState } from '@wordpress/element';
import {
    Popover, __experimentalToolsPanel as ToolsPanel,__experimentalToolsPanelItem as ToolsPanelItem,
    __experimentalHStack as HStack,__experimentalVStack as VStack, __experimentalText as Text,
    Button,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const videoSVGs = {
    play: (
        `<svg  viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="5 3 19 12 5 21 5 3" />
        </svg>`
    ),
    pause: (
        `<svg  viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="6" y="4" width="4" height="16" />
            <rect x="14" y="4" width="4" height="16" />
        </svg>`
    ),
    stop: (
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 30" class="gkit-icon"><path d="M35.716,10.449a.932.932,0,0,0-1.289.3.945.945,0,0,0,.3,1.3,3.493,3.493,0,0,1,0,5.908L19.386,27.58a3.4,3.4,0,0,1-3.509.09A3.442,3.442,0,0,1,14.1,24.626V5.374A3.442,3.442,0,0,1,15.877,2.33a3.4,3.4,0,0,1,3.509.09l8.93,5.6a.932.932,0,0,0,1.289-.3.945.945,0,0,0-.3-1.3l-8.93-5.6A5.236,5.236,0,0,0,14.969.684a5.3,5.3,0,0,0-2.743,4.69V24.626a5.31,5.31,0,0,0,8.15,4.551l15.34-9.626a5.382,5.382,0,0,0,0-9.1Z" transform="translate(-12.226)"></path></svg>`
    ),
    rewind: (
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="gkit-icon"><path d="M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"></path></svg>`
    ),
    record: (
        `<svg version="1.1" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32" class="gkit-icon"><title>play</title>
            <path d="M30.231 9.075c-1.119-2.175-2.756-4.094-4.725-5.55-0.288-0.212-0.7-0.15-0.913 0.138s-0.15 0.7 0.137 0.912c1.813 1.338 3.313 3.1 4.344 5.1 1.081 2.094 1.625 4.356 1.625 6.725 0 8.106-6.594 14.7-14.7 14.7s-14.7-6.594-14.7-14.7 6.594-14.7 14.7-14.7c0.363 0 0.65-0.294 0.65-0.65s-0.288-0.65-0.65-0.65c-8.825 0-16 7.175-16 16s7.175 16 16 16 16-7.175 16-16c0-2.544-0.613-5.075-1.769-7.325zM11.906 8.969c-0.206 0.119-0.331 0.331-0.331 0.569v14.294c0 0.363 0.294 0.65 0.65 0.65s0.65-0.294 0.65-0.65v-13.15l9.644 5.737-7.088 4.569c-0.3 0.194-0.387 0.6-0.194 0.9s0.6 0.387 0.9 0.194l7.975-5.137c0.188-0.125 0.3-0.331 0.3-0.556-0.006-0.225-0.125-0.431-0.319-0.55l-11.531-6.863c-0.206-0.119-0.45-0.119-0.656-0.006z"></path>
            </svg>`
    ),
};

const animationOptions = Object.entries(videoSVGs).map(([name, svg]) => ({ name, svg }));

export const VideoIconSelector = ({ animationData, onChange }) => {
    const animationvalue = animationData;

    const [isVisible, setIsVisible] = useState(false);
    const [popoverAnchor, setPopoverAnchor] = useState();

    const toggleVisible = () => setIsVisible((prev) => !prev);

    const handleAnimationClick = (aname) => {
        onChange(aname);
        setIsVisible(false);
    };

    const resetAll = () => {
        handleAnimationClick('play');
    };

    return (
        <div className="vayu_blocks_animation_panel vb-adv-video-selector-icon-panel">
            <ToolsPanel
                label={__('Icon')}
                className="vayu_block_animation_name"
                resetAll={resetAll}
            >
                <ToolsPanelItem
                    className="vayu_blocks_animation_toolspanel_item"
                    hasValue={() => !!animationvalue && animationvalue !== 'none'}
                    label={__('icon', 'vayu-blocks')}
                    onDeselect={() => handleAnimationClick('none')}
                    isShownByDefault
                >
                    <Button
                        ref={setPopoverAnchor}
                        onClick={toggleVisible}
                        className={`block-editor-panel-animation-settings__dropdown ${isVisible ? 'is-open' : ''}`}
                    >
                        <HStack alignment="left" spacing={2}>
                            <div className="vayu-blocks-panel-icon" style={{ width: 24, height: 24 }} dangerouslySetInnerHTML={{ __html: videoSVGs[animationvalue] }}>

                            </div>
                        </HStack>
                    </Button>
                </ToolsPanelItem>
            </ToolsPanel>

            {isVisible && (
                <Popover
                    placement="left-start"
                    className="vayu_blocks_toolspanel_items_popover vb-adv-video-selector-icon-panel"
                    anchor={popoverAnchor}
                    onClose={() => setIsVisible(false)}
                    offset={35}
                    resize
                >
                    <VStack style={{ padding: '10px', width: '250px' }}>
                        <div>
                            <h4>{__('Video Icon', 'vayu-blocks')}</h4>
                            <p>{__('Select an video icon for your element.', 'vayu-blocks')}</p>
                        </div>

                        <HStack justify="flex-start" spacing={4} wrap={true}>
                            {animationOptions.map(({ name, svg }) => (
                                <div
                                    key={name}
                                    className={`vayu-blocks-ihover-main-panel ${animationvalue === svg ? 'selected' : ''}`}
                                    onClick={() => handleAnimationClick(name,svg)}
                                    title={name}
                                    style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', width: 60 }}
                                >
                                    <div style={{ width: 24, height: 24 }} dangerouslySetInnerHTML={{ __html: svg }}>
                                    </div>
                                </div>
                            ))}
                        </HStack>
                    </VStack>
                </Popover>
            )}
        </div>
    );
};
